import { useRef } from 'react';
import { Map as LeafletMap } from 'leaflet';
import { MAP_CONFIG, getStateBounds } from '../lib/mapConfig';
import { Mill, StateType } from '../lib/types';

export const useMapControls = (map: LeafletMap | null) => {
  const animatingRef = useRef(false);

  // Fly to state bounds with smooth animation
  const flyToState = (state: StateType) => {
    if (!map || animatingRef.current) return;

    animatingRef.current = true;
    const bounds = getStateBounds(state);

    map.flyToBounds(bounds, {
      duration: MAP_CONFIG.animationDuration / 1000, // Convert to seconds
      padding: [30, 30], // Reduced padding to prevent bouncing
      maxZoom: MAP_CONFIG.stateZoomLevel,
    });

    setTimeout(() => {
      animatingRef.current = false;
    }, MAP_CONFIG.animationDuration);
  };

  // Fly to mill location
  const flyToMill = (mill: Mill) => {
    if (!map || animatingRef.current) return;

    animatingRef.current = true;

    map.flyTo([mill.latitude, mill.longitude], MAP_CONFIG.millZoomLevel, {
      duration: MAP_CONFIG.animationDuration / 1000,
    });

    setTimeout(() => {
      animatingRef.current = false;
    }, MAP_CONFIG.animationDuration);
  };

  return {
    flyToState,
    flyToMill,
  };
};
